import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import useAxios from 'axios-hooks';
import uniqueId from 'lodash.uniqueid';
import isEmpty from 'lodash.isempty';
import cn from 'classnames';

import { Button } from '../../../../components';

const Provider = ({ data, type = 'attending' }) => {
	return (
		<div className="col-md-6">
			<h4>{type === 'attending' ? 'Attending Provider' : 'Primary Care Provider'}</h4>
			<p>
				<strong>{data[`${type}_first_name`]} {data[`${type}_last_name`]} - {data[`${type}_credential`]}</strong><br />
				<strong>{data[`${type}_specialty`]}</strong><br />
				{data[`${type}_address_1`]}<br />
				{!isEmpty(data[`${type}_address_2`]) && (
					<React.Fragment>
						{data[`${type}_address_2`]}<br />
					</React.Fragment>
				)}
				{data[`${type}_city`]}, {data[`${type}_state`]} {data[`${type}_zip`]}<br />
				{data[`${type}_phone`]}<br />
			</p>
		</div>
	);
};

Provider.propTypes = {
	data: PropTypes.object,
	type: PropTypes.string,
};

const AdditionalDetailsModal = ({ isOpen, onClose, userId, adt }) => {
	const [{ data, loading, /* error */ }, getADTDetail] = useAxios({
		method: 'GET',
		url: `/providers/${userId}/adt-detail`
	}, { manual: true });

	useEffect(() => {
		if (isOpen) {
			getADTDetail({
				params: {
					adt_id: adt.id
				}
			});
		}
	}, [isOpen, adt]);

	return (
		<Modal
			isOpen={isOpen}
			contentLabel="ADT Additional Details"
			className={cn('modal-dialog', 'adt-additional-details', { 'modal-xl': (!loading && data && data.hl7_file) })}
		>
			<div className="modal-content">
				<div className="modal-header">
					<div className="clearfix">
						<div className="pull-right">
							<button className="btn btn-link" onClick={onClose}>
								<em className="fa fa-lg fa-times" />
							</button>
						</div>
						<h3 className="modal-title">
							{adt.patient_first_name} {adt.patient_last_name} {adt.patient_gender && `(${adt.patient_gender})`}{' '}
							<small>Additional Details</small>
						</h3>
					</div>
				</div>
				<div className="modal-body">
					{!loading && data && data.detail && data.detail.map((item) => (
						<React.Fragment key={uniqueId('detailItem-')}>
							<div className="row">
								{item.attending_last_name && (
									<Provider data={item} />
								)}
								{item.pcp_last_name && (
									<Provider data={item} type="pcp" />
								)}
							</div>
							{!item.attending_last_name && !item.pcp_last_name && (
								<span>No Provider data found</span>
							)}
						</React.Fragment>
					))}
					{!loading && data && data.hl7_file && (
						<React.Fragment>
							<h4>HL7 Data</h4>
							<pre>{data.hl7_file}</pre>
						</React.Fragment>
					)}
					{loading && (
						<em className="fa fa-spin fa-circle-o-notch" />
					)}
				</div>
				<div className="modal-footer">
					<Button
						title="Close"
						onClick={onClose}
						large
						// primary
						// className="ml"
					/>
				</div>
			</div>
		</Modal>
	);
};

AdditionalDetailsModal.propTypes = {
	isOpen: PropTypes.bool,
	onClose: PropTypes.func,
	userId: PropTypes.number,
	adt: PropTypes.object,
};

export default AdditionalDetailsModal;
